<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!--begin::Form-->
    <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            {{ this.$route.meta.breadcrumb }}
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <!-- Begin:Invoice No -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">Invoice No :</label>
                <input
                  id="odcInvoiceNo"
                  name="odcInvoiceNo"
                  v-model="odcInvoiceNo"
                  type="text"
                  maxlength="450"
                  class="form-control"
                  placeholder="Invoice No."
                />
                <span class="form-text"></span>
              </div>
            </div>
            <!-- End:Invoice No -->

            <!-- Begin:งบประมาณ input -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">Invoice Date :</label>
                <div class="input-group date">
                  <input
                    type="text"
                    class="form-control"
                    id="odcInvoiceDate"
                    name="odcInvoiceDate"
                    ref="odcInvoiceDate"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text">
                      <i class="la la-calendar-check-o"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- End:งบประมาณ input -->

            <!-- Begin:Vandor select2 -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">Supplier :</label>
                <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'odcSupplier'"
                  :name="'odcSupplier'"
                  :select2-options="odcSupplierOptions"
                  v-model="odcSupplier"
                  ref="odcSupplierSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
            <!-- End:ประเภทงบประมาณ select2 -->
          </div>
          <!-- Begin:Picture element -->
          <div class="row">
            <div class="col-xl-12">
              <div class="form-group">
                <label>แนบไฟล์:</label>
                <button
                  type="button"
                  class="btn m-btn--pill btn-info btn-block uploader-btn col-xl-2"
                  id="uploader-order"
                  :data-ref="uuid"
                >
                  <i class="flaticon-upload-1"></i>ไฟล์
                </button>
                <div class="row" id="container-file"></div>
              </div>
            </div>
          </div>
          <!-- End:Picture element -->

          <div class="kt-section kt-section--first">
            <h3 class="kt-section__title">รายการสินค้า/ทรัพย์สิน:</h3>
            <div class="kt-section__body">
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table
                    class="table table-sm table-striped table-bordered table-hover table-checkable"
                    style="min-width: 1440px;"
                  >
                    <thead>
                      <tr>
                        <th class="text-center" width="5%">ลำดับ</th>
                        <th class="text-center" width="15%">รหัส/ชื่อสินค้า</th>
                        <th class="text-center" width="15%">จำนวน</th>
                        <th class="text-center" width="15%">ราคา</th>
                        <th class="text-center" width="15%">รวม</th>
                        <th class="text-center" width="15%">งบประมาณ</th>
                        <th class="text-center" width="15%">โควต้า</th>
                        <th class="text-center" width="5%">คำสั่ง</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="odcitems == null || odcitems.length == 0">
                        <td colspan="9" class="text-muted text-center">
                          คลิก + เพื่อเพิ่มรายการใหม่
                        </td>
                      </tr>
                      <template v-for="(item, i) in odcitems">
                        <order-item-row
                          ref="jobItems"
                          :key="i"
                          :rowIndex="i"
                          :item="item"
                          @removeItem="onRemoveItemClick"
                        ></order-item-row>
                      </template>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colspan="9">
                          <button
                            type="button"
                            class="btn btn-sm btn-brand"
                            @click.prevent="onAddItemClick"
                          >
                            <i class="fa fa-plus"></i> เพิ่มรายการใหม่
                          </button>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl-12">
            <label class="kt-button">
              <!-- <button type="button" class="btn btn-default" id="addProduct" @click="addProduct">
                <i class="fas fa-plus"></i> เพิ่มรายการ
              </button>-->
            </label>
          </div>
        </div>
      </div>

      <div class="kt-portlet__foot">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="$router.go(-1)"
        >
          <i class="la la-close"></i> ย้อนกลับ
        </button>
        <button type="submit" class="btn btn-primary" data-dismiss="modal">
          <i class="la la-save"></i> บันทึกข้อมูล
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import datepicker from "../../../Shared/Datepicker";
import select2 from "../../../Shared/Select2";
import orderItemRow from "./OrderItemRow";
import plupload from "plupload";

export default {
  components: {
    select2,
    datepicker,
    orderItemRow,
  },
  data() {
    var self = this;
    return {
      uuid: null,
      FileUpload: null,
      odcFilename: null,
      odcitems: [],
      i: 0,
      odcInvoiceNo: null,
      odcInvoiceDate: null,
      odcSupplier: null,
      odcSummary: 0,
      odcFileChk: false,
      odcSupplierOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Vendors/Select2Vendor",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    onAddItemClick(e) {
      this.odcitems.push({
        odcMaterialCode: null,
        odcQuantity: 0,
        odcPrice: 0,
        odcTotal: null,
        odcBudgetId: null,
        odcQuotaId: null,
      });
    },
    onRemoveItemClick(index, delItem) {
      this.odcitems.splice(index, 1);
      for (let i = 0; i < this.odcitems.length; i++) {}
    },
    initPlUploader() {
      let self = this;
      self.uuid = this._uid;

      var uploader = new plupload.Uploader({
        runtimes: "html5,flash,silverlight,html4",
        multi_selection: false,
        browse_button: "uploader-order",
        url: "#",

        chunk_size: "1mb",
        max_retries: 5,
        filters: {
          max_file_size: "10mb",
          mime_types: [
            {
              title: "doc files",
              extensions: "jpg,jpeg,png,JPG,JPEG,PNG,pdf,PDF,xlsx,xls,doc,docx",
            },
          ],
        },
        resize: {
          width: 300,
          quality: 100,
        },
        init: {
          FilesAdded: function(up, files) {
            var $imageContainer = $("#container-file");
            if ($("#files", $imageContainer).data("file-id") != null) {
              $imageContainer.empty();
            }
            plupload.each(files, function(file) {
              self.odcFilename = file.name;
              if (
                $('div[data-file-name="' + file.name + '"]', $imageContainer)
                  .length == 0
              ) {
                var nativeData = file.getNative();

                if (files[0]) {
                  self.odcFileChk = true;
                  self.FileUpload = {
                    isNew: true,
                    fileDataContext: nativeData,
                    fileId: file.id,
                    fileName: file.name,
                  };
                }

                if (typeof FileReader != "undefined") {
                  var image_holder = $(
                    '<div class="col-md-4 m--margin-top-20 loader loader-secondary bg-overlay img-wrap" id="' +
                      file.id +
                      '"></div>'
                  );
                  $(
                    '<div style="display:none" id="files" data-file-id="' +
                      file.id +
                      '" data-file-name="' +
                      file.name +
                      '" data-file-uploaded="false" alt="' +
                      file.name +
                      '">' +
                      file.name +
                      '<div id="myProgress" class=" progress' +
                      file.id +
                      '"><div id="myBar' +
                      '" class="progress-bar bg-success"><b></b></div ></div></div>'
                  ).appendTo(image_holder);
                  image_holder.appendTo($imageContainer);
                  var reader = new FileReader();
                  reader.onload = function(e) {
                    $("div[data-file-id=" + file.id + "]")
                      .attr("src", e.target.result)
                      .show();
                  };
                  reader.readAsDataURL(nativeData);
                }
              }
            });
            up.start();
          },

          UploadProgress: function(up, file) {
            document
              .getElementById(file.id)
              .getElementsByTagName("b")[0].innerHTML =
              "<span>" + file.percent + "%</span>";
            document.getElementById("myBar").style.width =
              file.percent - 1 + "%";
          },
        },
      });
      uploader.init();
    },
    async formSubmit(e) {
      let router = this.$router;
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      //Validate Item not null
      if (self.odcitems.length == 0) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "กรุณาเพิ่มรายการสินค้า/ทรัพย์สิน",
          "warning"
        );
        return false;
      }

      //Validate File
      if(self.odcFileChk == false)
      {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "กรุณาแนบไฟล์",
          "warning"
        );
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      var sItems = [];
      self.odcitems.forEach((element) => {
        sItems.push({
          MATERIALCODE: element.odcMaterialCode,
          Price: element.odcPrice,
          QTY: element.odcQuantity,
          Summary: element.odcSummary,
          BudgetId: element.odcBudgetId,
          QuotaId: element.odcQuotaId,
          Summary: element.odcTotal,
        });
      });

      let uploadedFile = null;

      if ( this.FileUpload && this.FileUpload.isNew && this.FileUpload.fileDataContext ) {
        try {
          const file = this.FileUpload;
          const formData = new FormData();
          formData.append("File", file.fileDataContext);
          formData.append("FolderName", "StockOrder");

          const uploadResponse = await axios.post("/Api/File/FileUpload", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });

          uploadedFile = {
            contentType: file.fileDataContext.type || "-",
            downloadUrl: uploadResponse.data.fileUrl,
            fileInfoId: uploadResponse.data.fileInfoId,
            fileName: file.fileName,
            gridFsId: uploadResponse.data.gridFsId,
            sysName: "-",
          };
        } catch (error) {
          console.error("เกิดข้อผิดพลาดในการอัปโหลดไฟล์:", error);
        }
      }

      axios({
        method: "post",
        url: "/Api/Stock",
        data: {
          invoiceNo: self.odcInvoiceNo,
          invoiceDate: self.odcInvoiceDate.format("DD/MM/YYYY"),
          vendorId: self.odcSupplier,
          stockItems: sItems,
          fileUpload: uploadedFile,
        },
      })
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                router.go(-1), self.$parent.reloadDataTable(false);
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
  },
  async mounted() {
    let self = this;

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    $(self.$refs.odcInvoiceDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    self.odcInvoiceDate = moment();
    $(self.$refs.odcInvoiceDate)
      .datepicker("update", self.odcInvoiceDate.format("DD/MM/YYYY"))
      .on("changeDate", function(e) {
        self.odcInvoiceDate = moment(e.date);
      });

    self.initPlUploader();

    $(this.$refs.form).validate({
      rules: {
        odcInvoiceNo: "required",
        odcInvoiceDate: "required",
        odcSupplier: "required",
      },
      messages: {
        odcInvoiceNo: "กรุณาระบุ InvoiceNo",
        odcInvoiceDate: "กรุณาระบุ InvoiceDate",
        odcSupplier: "กรุณาระบุ Supplier",
      },
    });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>



// WEBPACK FOOTER //
// App/Components/Master/Order/OrderCreate.vue